/**
Project: Voice Panel (c)
Title: App Routes  
Description: Application routes list
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import { VoiceAdminURLProps } from "../pages/common/settings/voice-admin-urls";
import VoiceSetup from "../pages/voice-setup/components/voice-setup";
import DomainSetup from "../pages/domain-setup/components/domain-setup";
import Routing from "../pages/routing/components/routing";
import usersSearch from "../pages/users/components/user-search";
import usersList from "../pages/users/components/user-list";
import ServiceNumbers from "../pages/service-numbers/components/service-numbers";
import AdminTypes from "../pages/admin-config/components/number-types";
import AdminDepartments from "../pages/admin-config/components/departments";
import AdminCarriers from "../pages/admin-config/components/carriers";
import AdminDeviceTypes from "../pages/admin-config/components/device-types";
// import NumberOrder from "../pages/inventory/components/number-order";
import NumberList from "../pages/inventory/components/number-list";
import NumberAdd from "../pages/inventory/components/number-add";
import NumberEdit from "../pages/inventory/components/number-edit";

const AppRoutes = [
  {
    partCode: "STP-COM",
    component: VoiceSetup,
    path: VoiceAdminURLProps.setup,
    labelKeyId: "content.setup",
    exactPath: true,
    navDisplay: true,
  },
  {
    partCode: "RTG-COM",
    component: Routing,
    path: VoiceAdminURLProps.routing,
    labelKeyId: "content.routing",
    exactPath: true,
    navDisplay: true,
  },
  {
    partCode: "ACT-COM",
    component: null,
    path: VoiceAdminURLProps.accounts,
    labelKeyId: "content.users",
    exactPath: true,
    navDisplay: true,
    child: [
      {
        partCode: "ACT-USR",
        component: usersSearch,
        path: VoiceAdminURLProps.usersFilter,
        labelKeyId: "content.users",
        exactPath: true,
        navDisplay: true,
      },
      {
        partCode: "ACT-USR",
        component: usersList,
        path: VoiceAdminURLProps.usersList,
        labelKeyId: "content.users",
        exactPath: true,
        navDisplay: false,
      },
      {
        partCode: "ACT-CLS",
        component: ServiceNumbers,
        path: VoiceAdminURLProps.serviceNumbers,
        labelKeyId: "content.serviceNumbers",
        exactPath: true,
        navDisplay: true,
      },
    ],
  },
  {
    partCode: "NUM-COM",
    component: null,
    path: VoiceAdminURLProps.numbers,
    labelKeyId: "content.numbers",
    exactPath: true,
    navDisplay: true,
    child: [
      {
        partCode: "NUM-INL",
        component: NumberList,
        path: VoiceAdminURLProps.numberList,
        labelKeyId: "content.inventory",
        exactPath: true,
        navDisplay: true,
      },
      // {
      //   partCode: "NUM-ORD",
      //   component: NumberOrder,
      //   path: VoiceAdminURLProps.numberOrder,
      //   labelKeyId: "content.buyNumbers",
      //   exactPath: true,
      //   navDisplay: false,
      // },
      {
        partCode: "NUM-ADD",
        component: NumberAdd,
        path: VoiceAdminURLProps.numberAdd,
        labelKeyId: "content.add",
        exactPath: true,
      },
      {
        partCode: "NUM-EDT",
        component: NumberEdit,
        path: VoiceAdminURLProps.numberEdit,
        labelKeyId: "content.edit",
        exactPath: true,
      },
      {
        partCode: "CFG-DPL",
        component: AdminDepartments,
        path: VoiceAdminURLProps.controlDepartments,
        labelKeyId: "content.control",
        exactPath: true,
        navDisplay: true,
      },
      {
        partCode: "CFG-NTL",
        component: AdminTypes,
        path: VoiceAdminURLProps.controlNumbertypes,
        labelKeyId: "content.type",
        exactPath: true,
        navDisplay: false,
      },
      {
        partCode: "CFG-DTL",
        component: AdminDeviceTypes,
        path: VoiceAdminURLProps.controlDevicetypes,
        labelKeyId: "content.deviceType",
        exactPath: true,
        navDisplay: false,
      },
      {
        partCode: "CFG-CRL",
        component: AdminCarriers,
        path: VoiceAdminURLProps.controlCarriers,
        labelKeyId: "content.carriers",
        exactPath: true,
        navDisplay: false,
      },
    ],
  },
];

export default AppRoutes;
